import { ReactElement } from 'react';
import { AppShell } from '../AppShell';

export const AppShellRouter = (): ReactElement => {
  return <AppShell />;
};
